import { render } from "./TemplatesEdit.vue?vue&type=template&id=6dcc29c0&scoped=true"
import script from "./TemplatesEdit.vue?vue&type=script&lang=js"
export * from "./TemplatesEdit.vue?vue&type=script&lang=js"

import "./TemplatesEdit.vue?vue&type=style&index=0&id=6dcc29c0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcc29c0"]])

export default __exports__